import ToolsList from "./tools-list";

const Tools = ({
  tools,
  description,
  service,
  analytics,
  isAddedImage,
}: {
  tools: string[];
  description: string[];
  service: string;
  analytics: { sendClickTool: Function };
  isAddedImage: boolean;
}): JSX.Element => {
  return (
    <ul className="service__tools">
      <ToolsList tools={tools} description={description} service={service} analytics={analytics} isAddedImage={isAddedImage} />
    </ul>
  );
};

export default Tools;
